import { Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { GlobalConstantsChart, GlobalConstantsDom, GlobalConstantsTexte, GlobalFunctions } from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';
import { ErgebnisGebaeude } from 'src/app/data/ws/ergebnis/gebaeude/ergebnis-gebaeude.model';
import { Functions } from 'src/app/functions/functions.module';
import { ConstantsDom } from 'src/app/immutable/constants-dom';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { LocalService } from 'src/app/services/local.service';

@Component({
  selector: 'app-chart-inv-bed-kb',
  templateUrl: './chart-inv-bed-kb.component.html',
  styleUrls: ['./chart-inv-bed-kb.component.css'],
})
export class ChartInvBedKbComponent implements OnInit {
  @Input() isPro!: boolean;

  private guid: string = Guid.create().toString();
  private ergebnisseSubscription!: Subscription;
  private chartInstance!: Chart;
  private isUpdated = false;

  constructor(public localService: LocalService) {}

  ngOnInit(): void {
    this.ergebnisseSubscription = this.localService.diagramErgebnisse.subscribe(
      (ergebnisse) => {
        if (ergebnisse) {
          this.createChart(ergebnisse.ergebnisGebaeudeList!);
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.ergebnisseSubscription) {
      this.ergebnisseSubscription.unsubscribe();
    }
  }
 
  ngAfterViewChecked(): void {
    if (!this.isUpdated) {
      const element = document.getElementById(ConstantsDom.DOM_CHART_INV_BED_KB);
      if (element) { 
        element.setAttribute(GlobalConstantsDom.DOM_ID, this.guid);
        this.isUpdated = true;
      }
    }
  }

  async createChart(ergebnisGebaeudeList: ErgebnisGebaeude[]) {
    await new Promise((f) => setTimeout(f, 1)); // M 

    let chartDataSets: any[] = [];
 
    let temp : ErgebnisGebaeude[] = ergebnisGebaeudeList;

    if (ergebnisGebaeudeList.length != 0) {
      temp  = 
      ergebnisGebaeudeList.length > 1 
          ? ergebnisGebaeudeList.slice(1) 
          : ergebnisGebaeudeList.slice(0, 1);


          temp[0].ergebnisInvBedKbKomplett.ergebnisInvBedKbList.forEach(
        (entry, i) => {
          let data: number[] = [];

          temp.forEach((entry2) => {
            if (this.isPro)
              data.push(
                entry2.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
                  .ergebnisInvBedKbEinzelSumme.jeTierplatz
              );
            else
              data.push(
                entry2.ergebnisInvBedKbKomplett.ergebnisInvBedKbList[i]
                  .ergebnisInvBedKbEinzelSumme.gesamt
              );
          });

          chartDataSets.push({
            label: entry.kostenblock,
            backgroundColor: entry.diagrammfarbe,
            data: data,
          });
        }
      );
    }

    let titleText: string = ConstantsTexte.INVESTITIONSBEDARF_NACH_KOSTENBLOECKEN;
    let seitenUeberschriftText: string = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO;
    let nachkommastellen: number = 0;
    if (this.isPro) {

      if (this.localService.istGebaeude.value)
      {
        if ((temp[0].gebaeude.flaechenVolumen.find(fv => fv.istKostenrelevant)?.dimension) === GlobalConstantsTexte.EINHEIT_M3) {
          titleText = ConstantsTexte.INVESTITIONSBEDARF_JE_M3_NUTZVOLUMEN_NACH_KB;
        } else {
          titleText = ConstantsTexte.INVESTITIONSBEDARF_JE_M2_NUTZFLAECHE_NACH_KB;
        }

        seitenUeberschriftText = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO_M3;    
      }
      else
      {
        titleText = ConstantsTexte.INVESTITIONSBEDARF_JE_TP_NACH_KB;
        seitenUeberschriftText = ConstantsTexte.INVESTITIONSBEDARF_IN_EURO_TP;
      }

      nachkommastellen = 0;
    }

    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    this.chartInstance = GlobalFunctions.getDiagramm(
      this.guid,
      Functions.getChartLabels(
        temp,
        this.localService.istGebaeude.value
      ),
      chartDataSets,
      titleText,
      seitenUeberschriftText,
      nachkommastellen,
      true,
      GlobalConstantsChart.FARBE_SCHWARZ
    );
  }
}
